export { IncomingInvoiceGeneral } from "./incoming-invoice-general";
